import React, { useState, useEffect } from "react";
import styles from "../../style/components/chat/ChatHeader.module.css";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";
import { CiSearch } from "react-icons/ci";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const ChatHeader = ({
  userName,
  status,
  userImage,
  typing,
  onHeaderClick,
  type,
  onSearch,
  searchQuery = "",
  pageFrom,
}) => {
  const [imgError, setImgError] = useState(false);
  const [showTyping, setShowTyping] = useState(false);
  const [prevUserName, setPrevUserName] = useState(userName);
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setImgError(false);
  }, [userImage]);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    if (onSearch) {
      onSearch(query);
    }
  };

  const handleCloseSearch = () => {
    setShowSearch(false);
    if (onSearch) {
      onSearch("");
    }
  };

  useEffect(() => {
    if (userName !== prevUserName) {
      setShowTyping(false);
      setPrevUserName(userName);
    }
  }, [userName, prevUserName]);

  useEffect(() => {
    let timer;
    if (typing) {
      timer = setTimeout(() => {
        setShowTyping(true);
      }, 500);
    } else {
      timer = setTimeout(() => {
        setShowTyping(false);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [typing]);

  const handleSearchClick = () => {
    setShowSearch(true);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter" && onSearch) {
      onSearch(searchQuery);
    }
  };

  const BASE_URL = process.env.REACT_APP_API_URL;

  return (
    <div className={styles.ChatHeaderMaincontentHeader}>
      {type === "channel" ? (
        <div
          className={styles.ChatHeaderMaincontentHeadersb}
          onClick={onHeaderClick}
        >
          <div className={styles.ChatHeaderMaincontentPara}>
            <p className={styles.ChatHeaderMaincontentHdpara1}>{userName}</p>
          </div>
        </div>
      ) : (
        <div
          className={styles.ChatHeaderMaincontentHeadersb}
          onClick={onHeaderClick}
        >
          <div
            className={styles.ChatHeaderMaincontentHeaderimgWrapper}
            // onClick={onHeaderClick}
          >
            <div className={styles.ChatHeaderMaincontentHeaderimg}>
              {imgError || userImage === null ? (
                <FallbackAvatar name={userName} size={35} />
              ) : (
                <img
                  src={`${BASE_URL}${userImage}`}
                  alt="User avatar"
                  onError={() => setImgError(true)}
                />
              )}
            </div>
          </div>

          <div
            className={styles.ChatHeaderMaincontentPara}
            onClick={onHeaderClick}
          >
            <p className={styles.ChatHeaderMaincontentHdpara1}>{userName}</p>
            {showTyping && (
              <p className={styles.ChatHeaderMaincontentHdpara2}>typing...</p>
            )}
          </div>
        </div>
      )}

      {showSearch && (
        <div className={styles.searchBarContainer}>
          <div className={styles.searchInputWrapper}>
            <CiSearch size={20} className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Search messages..."
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyPress={handleSearchKeyPress}
              className={styles.searchInput}
              autoFocus
            />
            <IoClose
              size={20}
              className={styles.closeIcon}
              onClick={handleCloseSearch}
            />
          </div>
        </div>
      )}

      <div className={styles.iconsContainer}>
        {!showSearch && pageFrom !== "activity" && (
          <div
            className={`${styles.iconWrapper} ${styles.searchIconWrapper}`}
            onClick={handleSearchClick}
          >
            <CiSearch size={20} className={styles.headerIcon} />
          </div>
        )}
        <div className={styles.iconWrapper} onClick={() => navigate("/help")}>
          <IoIosInformationCircleOutline
            size={20}
            className={styles.headerIcon}
          />
        </div>
        {/* <div className={styles.iconWrapper} onClick={handleCloseChat}>
          <IoCloseOutline size={20} />
        </div> */}
      </div>
    </div>
  );
};

export default ChatHeader;
